[
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.CollectionMasthead",
                "collectionId": "83649",
                "title": "Biryani",
                "description": "Taste these delectable classics, delectable biryanis to make your day.",
                "imageId": "v1674029961/PC_Creative%20refresh/3D_bau/collections_new/Biriyani.png",
                "aspectRatio": "3.44",
                "cta": {
                    "link": "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani,layout_cuisine_biryani,ads_pc_biryani,biryani",
                    "type": "collectionv2"
                },
                "type": "COLLECTION_MASTHEAD_TYPE_IMAGE_WITH_TEXT",
                "count": "25 restaurants"
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
                "sortConfigs": [
                    {
                        "key": "relevance",
                        "title": "Relevance (Default)",
                        "selected": true,
                        "defaultSelection": true
                    },
                    {
                        "key": "deliveryTimeAsc",
                        "title": "Delivery Time"
                    },
                    {
                        "key": "modelBasedRatingDesc",
                        "title": "Rating"
                    },
                    {
                        "key": "costForTwoAsc",
                        "title": "Cost: Low to High"
                    },
                    {
                        "key": "costForTwoDesc",
                        "title": "Cost: High to Low"
                    }
                ],
                "restaurantCount": 25,
                "facetList": [
                    {
                        "label": "Veg/Non-veg",
                        "id": "isVeg",
                        "selection": "SELECT_TYPE_SINGLESELECT",
                        "facetInfo": [
                            {
                                "label": "Pure veg",
                                "id": "isVegfacetquery2",
                                "analytics": {},
                                "openFilter": true
                            },
                            {
                                "label": "Non Veg",
                                "id": "isVegfacetquery3",
                                "analytics": {}
                            }
                        ],
                        "viewType": "VIEW_TYPE_FLATTENED",
                        "subLabel": "Filter by"
                    },
                    {
                        "label": "Delivery Time",
                        "id": "deliveryTime",
                        "selection": "SELECT_TYPE_SINGLESELECT",
                        "facetInfo": [
                            {
                                "label": "Less than 30 mins",
                                "id": "deliveryTimefacetquery2",
                                "analytics": {},
                                "openFilter": true
                            },
                            {
                                "label": "Less than 45 mins",
                                "id": "deliveryTimefacetquery3",
                                "analytics": {}
                            }
                        ],
                        "viewType": "VIEW_TYPE_FLATTENED",
                        "subLabel": "Filter by"
                    },
                    {
                        "label": "Cost for two",
                        "id": "costForTwo",
                        "selection": "SELECT_TYPE_MULTISELECT",
                        "facetInfo": [
                            {
                                "label": "Rs. 300-Rs. 600",
                                "id": "costForTwofacetquery3",
                                "analytics": {},
                                "openFilter": true
                            },
                            {
                                "label": "Less than Rs. 300",
                                "id": "costForTwofacetquery5",
                                "analytics": {},
                                "openFilter": true
                            }
                        ],
                        "viewType": "VIEW_TYPE_HALF_CARD",
                        "subLabel": "Filter by"
                    }
                ]
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                "layout": {
                    "rows": 1,
                    "widgetPadding": {
                        "left": 16,
                        "top": 20,
                        "right": 16,
                        "bottom": 16
                    },
                    "scrollBar": {},
                    "widgetTheme": {
                        "defaultMode": {
                            "backgroundColour": "#FFFFFF",
                            "theme": "THEME_TYPE_LIGHT"
                        },
                        "darkMode": {
                            "backgroundColour": "#1B3028",
                            "theme": "THEME_TYPE_DARK"
                        }
                    }
                },
                "id": "restaurantCountWidget",
                "gridElements": {
                    "infoWithStyle": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
                        "text": "Restaurants to explore",
                        "headerStyling": {
                            "textSize": 15,
                            "textColor": "text_color_highest_emphasis",
                            "textFontName": "FONT_NAME_HEADER_H5",
                            "maxLines": 1
                        }
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "619437",
                    "name": "New Sagar Restaurant & Bakers",
                    "cloudinaryImageId": "d1f10ce89a255063f16ecc476d243cda",
                    "locality": "Jeedimetla & Chintal",
                    "areaName": "Suraram",
                    "costForTwo": "₹400 for two",
                    "cuisines": ["Indian", "Chinese", "Fast Food"],
                    "avgRating": 4.1,
                    "parentId": "369112",
                    "avgRatingString": "4.1",
                    "totalRatingsString": "1K+",
                    "sla": {
                        "deliveryTime": 24,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-25 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "nextCloseTime": "2024-02-05 02:00:00",
                        "opened": true
                    },
                    "badges": {},
                    "isOpen": true,
                    "type": "F",
                    "badgesV2": {
                        "entityBadges": {
                            "textExtendedBadges": {},
                            "textBased": {},
                            "imageBased": {}
                        }
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "40% OFF",
                        "subHeader": "UPTO ₹80"
                    },
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                    },
                    "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                            "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                            "lottie": {},
                            "video": {}
                        }
                    },
                    "reviewsSummary": {},
                    "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                    "restaurantOfferPresentationInfo": {},
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                },
                "analytics": {},
                "cta": {
                    "link": "swiggy://menu?restaurant_id=619437&source=collection&query=Biryani",
                    "text": "RESTAURANT_MENU",
                    "type": "DEEPLINK"
                },
                "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food"
            },
            "relevance": {
                "type": "RELEVANCE_TYPE_ON_MENU_RETURN",
                "sectionId": "MENU_RETURN_FOOD"
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "537772",
                    "name": "Vijwal Grand Restaurant",
                    "cloudinaryImageId": "ca18d5b0e7de9116b7df16245a451d23",
                    "locality": "Surarammain Road",
                    "areaName": "Jeedimetla & Chintal",
                    "costForTwo": "₹400 for two",
                    "cuisines": ["Biryani", "Snacks", "Arabian"],
                    "avgRating": 3.6,
                    "parentId": "323231",
                    "avgRatingString": "3.6",
                    "totalRatingsString": "100+",
                    "sla": {
                        "deliveryTime": 25,
                        "lastMileTravel": 3.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "3.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "nextCloseTime": "2024-02-05 01:00:00",
                        "opened": true
                    },
                    "badges": {},
                    "isOpen": true,
                    "aggregatedDiscountInfoV2": {},
                    "type": "F",
                    "badgesV2": {
                        "entityBadges": {
                            "textExtendedBadges": {},
                            "textBased": {},
                            "imageBased": {}
                        }
                    },
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                    },
                    "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                            "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                            "lottie": {},
                            "video": {}
                        }
                    },
                    "reviewsSummary": {},
                    "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                    "restaurantOfferPresentationInfo": {},
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                },
                "analytics": {},
                "cta": {
                    "link": "swiggy://menu?restaurant_id=537772&source=collection&query=Biryani",
                    "text": "RESTAURANT_MENU",
                    "type": "DEEPLINK"
                },
                "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food"
            },
            "relevance": {
                "type": "RELEVANCE_TYPE_ON_MENU_RETURN",
                "sectionId": "MENU_RETURN_FOOD"
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "684252",
                    "name": "Red Bucket Biryani",
                    "cloudinaryImageId": "be2bfa3b5dde1e71b41144e9b62878a9",
                    "locality": "Subhash nagar",
                    "areaName": "Suchitra Circle",
                    "costForTwo": "₹600 for two",
                    "cuisines": ["Biryani", "Seafood"],
                    "avgRating": 4,
                    "parentId": "306664",
                    "avgRatingString": "4.0",
                    "totalRatingsString": "500+",
                    "sla": {
                        "deliveryTime": 20,
                        "lastMileTravel": 3.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-25 mins",
                        "lastMileTravelString": "3.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "nextCloseTime": "2024-02-05 02:00:00",
                        "opened": true
                    },
                    "badges": {},
                    "isOpen": true,
                    "aggregatedDiscountInfoV2": {},
                    "type": "F",
                    "badgesV2": {
                        "entityBadges": {
                            "textBased": {},
                            "imageBased": {},
                            "textExtendedBadges": {}
                        }
                    },
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                    },
                    "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                            "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                            "lottie": {},
                            "video": {}
                        }
                    },
                    "reviewsSummary": {},
                    "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                    "restaurantOfferPresentationInfo": {},
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                },
                "analytics": {},
                "cta": {
                    "link": "swiggy://menu?restaurant_id=684252&source=collection&query=Biryani",
                    "text": "RESTAURANT_MENU",
                    "type": "DEEPLINK"
                },
                "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food"
            },
            "relevance": {
                "type": "RELEVANCE_TYPE_ON_MENU_RETURN",
                "sectionId": "MENU_RETURN_FOOD"
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "521301",
                    "name": "Maa Ooru Biryani",
                    "cloudinaryImageId": "pvt2evpdiq2bm8jr77g4",
                    "locality": "Kompally",
                    "areaName": "Kompally",
                    "costForTwo": "₹300 for two",
                    "cuisines": ["Biryani", "Indian", "Andhra"],
                    "avgRating": 3.8,
                    "parentId": "606",
                    "avgRatingString": "3.8",
                    "totalRatingsString": "500+",
                    "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 4.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "4.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "nextCloseTime": "2024-02-05 02:00:00",
                        "opened": true
                    },
                    "badges": {
                        "textExtendedBadges": [
                            {
                                "iconId": "guiltfree/GF_Logo_android_3x",
                                "shortDescription": "options available",
                                "fontColor": "#7E808C"
                            }
                        ]
                    },
                    "isOpen": true,
                    "type": "F",
                    "badgesV2": {
                        "entityBadges": {
                            "imageBased": {},
                            "textExtendedBadges": {
                                "badgeObject": [
                                    {
                                        "attributes": {
                                            "description": "",
                                            "shortDescription": "options available",
                                            "fontColor": "#7E808C",
                                            "iconId": "guiltfree/GF_Logo_android_3x"
                                        }
                                    }
                                ]
                            },
                            "textBased": {}
                        }
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO ₹50"
                    },
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                    },
                    "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                            "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                            "lottie": {},
                            "video": {}
                        }
                    },
                    "reviewsSummary": {},
                    "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                    "restaurantOfferPresentationInfo": {},
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                },
                "analytics": {},
                "cta": {
                    "link": "swiggy://menu?restaurant_id=521301&source=collection&query=Biryani",
                    "text": "RESTAURANT_MENU",
                    "type": "DEEPLINK"
                },
                "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food"
            },
            "relevance": {
                "type": "RELEVANCE_TYPE_ON_MENU_RETURN",
                "sectionId": "MENU_RETURN_FOOD"
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "168818",
                    "name": "Behrouz Biryani",
                    "cloudinaryImageId": "89fccaa76f2f760e2742b9e53d32bb69",
                    "locality": "Suchitra",
                    "areaName": "Quthbullapur",
                    "costForTwo": "₹500 for two",
                    "cuisines": [
                        "Biryani",
                        "Kebabs",
                        "Mughlai",
                        "Lucknowi",
                        "Hyderabadi",
                        "Desserts",
                        "Beverages"
                    ],
                    "avgRating": 4.1,
                    "parentId": "1803",
                    "avgRatingString": "4.1",
                    "totalRatingsString": "1K+",
                    "sla": {
                        "deliveryTime": 31,
                        "lastMileTravel": 4.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "4.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "nextCloseTime": "2024-02-05 01:00:00",
                        "opened": true
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "newg.png",
                                "description": "Gourmet"
                            }
                        ]
                    },
                    "isOpen": true,
                    "aggregatedDiscountInfoV2": {},
                    "type": "F",
                    "badgesV2": {
                        "entityBadges": {
                            "textBased": {},
                            "imageBased": {
                                "badgeObject": [
                                    {
                                        "attributes": {
                                            "imageId": "newg.png",
                                            "description": "Gourmet"
                                        }
                                    }
                                ]
                            },
                            "textExtendedBadges": {}
                        }
                    },
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                    },
                    "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                            "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                            "lottie": {},
                            "video": {}
                        }
                    },
                    "reviewsSummary": {},
                    "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                    "restaurantOfferPresentationInfo": {},
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                },
                "analytics": {},
                "cta": {
                    "link": "swiggy://menu?restaurant_id=168818&source=collection&query=Biryani",
                    "text": "RESTAURANT_MENU",
                    "type": "DEEPLINK"
                },
                "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food"
            },
            "relevance": {
                "type": "RELEVANCE_TYPE_ON_MENU_RETURN",
                "sectionId": "MENU_RETURN_FOOD"
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "341372",
                    "name": "Foodies Flavoroso",
                    "cloudinaryImageId": "jdnorl1zlwejocuen8il",
                    "locality": "Kompally",
                    "areaName": "Kompally",
                    "costForTwo": "₹220 for two",
                    "cuisines": ["Biryani", "Chinese", "Pizzas", "Beverages"],
                    "avgRating": 3.6,
                    "parentId": "82592",
                    "avgRatingString": "3.6",
                    "totalRatingsString": "1K+",
                    "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 4.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "4.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "nextCloseTime": "2024-02-05 02:00:00",
                        "opened": true
                    },
                    "badges": {},
                    "isOpen": true,
                    "type": "F",
                    "badgesV2": {
                        "entityBadges": {
                            "textExtendedBadges": {},
                            "textBased": {},
                            "imageBased": {}
                        }
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "40% OFF",
                        "subHeader": "UPTO ₹80"
                    },
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                    },
                    "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                            "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                            "lottie": {},
                            "video": {}
                        }
                    },
                    "reviewsSummary": {},
                    "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                    "restaurantOfferPresentationInfo": {},
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                },
                "analytics": {},
                "cta": {
                    "link": "swiggy://menu?restaurant_id=341372&source=collection&query=Biryani",
                    "text": "RESTAURANT_MENU",
                    "type": "DEEPLINK"
                },
                "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food"
            },
            "relevance": {
                "type": "RELEVANCE_TYPE_ON_MENU_RETURN",
                "sectionId": "MENU_RETURN_FOOD"
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "487891",
                    "name": "Chickpet Donne Biryani House",
                    "cloudinaryImageId": "x0vxvuopqmhiqiowfizw",
                    "locality": "Kompally",
                    "areaName": "Quthbullapur",
                    "costForTwo": "₹400 for two",
                    "cuisines": ["Biryani", "South Indian", "Chinese"],
                    "avgRating": 3.8,
                    "parentId": "5634",
                    "avgRatingString": "3.8",
                    "totalRatingsString": "1K+",
                    "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 5.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "5.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "nextCloseTime": "2024-02-05 03:00:00",
                        "opened": true
                    },
                    "badges": {
                        "textExtendedBadges": [
                            {
                                "iconId": "guiltfree/GF_Logo_android_3x",
                                "shortDescription": "options available",
                                "fontColor": "#7E808C"
                            }
                        ]
                    },
                    "isOpen": true,
                    "type": "F",
                    "badgesV2": {
                        "entityBadges": {
                            "textExtendedBadges": {
                                "badgeObject": [
                                    {
                                        "attributes": {
                                            "shortDescription": "options available",
                                            "fontColor": "#7E808C",
                                            "iconId": "guiltfree/GF_Logo_android_3x",
                                            "description": ""
                                        }
                                    }
                                ]
                            },
                            "textBased": {},
                            "imageBased": {}
                        }
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO ₹50"
                    },
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                    },
                    "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                            "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                            "lottie": {},
                            "video": {}
                        }
                    },
                    "reviewsSummary": {},
                    "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                    "restaurantOfferPresentationInfo": {},
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                },
                "analytics": {},
                "cta": {
                    "link": "swiggy://menu?restaurant_id=487891&source=collection&query=Biryani",
                    "text": "RESTAURANT_MENU",
                    "type": "DEEPLINK"
                },
                "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food"
            },
            "relevance": {
                "type": "RELEVANCE_TYPE_ON_MENU_RETURN",
                "sectionId": "MENU_RETURN_FOOD"
            }
        }
    }
]
